// Short readings for chart-wide patterns. Plain words, no em dashes.

// heavy: shown when the element holds 45%+ of the chart's weight.
// lead: shown when it leads but shares the chart with others (most charts).
export const ELEMENT_READINGS = {
  fire: {
    name: "Fire",
    heavy: "Fire carries much of your chart. You run on enthusiasm and momentum, and you think best by doing. Boredom costs you more than risk does.",
    lead: "Fire leads your chart. When you're stuck, starting something moves you faster than thinking it over.",
    light: "Fire is quiet in your chart. Motivation tends to come from meaning or necessity, rarely from adrenaline, so it helps to borrow spark from people who have it.",
  },
  earth: {
    name: "Earth",
    heavy: "Earth carries much of your chart. You trust what you can touch, build, and measure. You are steadying to be around, and you can mistake caution for wisdom.",
    lead: "Earth leads your chart. Something concrete (a plan, a meal, a walk) steadies you faster than a conversation does.",
    light: "Earth is quiet in your chart. Routines, money, and the body can feel like chores, and small concrete habits ground you faster than big plans.",
  },
  air: {
    name: "Air",
    heavy: "Air carries much of your chart. You understand things by talking them through and naming them, and you can end up explaining a feeling before you've finished having it.",
    lead: "Air leads your chart. You make sense of things by talking them through, and a good conversation can change your whole mood.",
    light: "Air is quiet in your chart. You know things before you can explain them, and talking a feeling through with someone helps more than you'd expect.",
  },
  water: {
    name: "Water",
    heavy: "Water carries much of your chart. You feel the room before you read it, and your memory is emotional. Your sensitivity is a real instrument, and it also needs a place to rest.",
    lead: "Water leads your chart. You read people by feel first, and you trust that read more than what they say.",
    light: "Water is quiet in your chart. Feelings can arrive late or sideways, often in the body first. Naming them out loud, even clumsily, closes the gap.",
  },
};

export const MODALITY_READINGS = {
  cardinal: "Your chart leans cardinal: you're built to start things and set direction.",
  fixed: "Your chart leans fixed: once you commit, you hold. Change has to make sense to you first.",
  mutable: "Your chart leans mutable: you adapt, translate, and finish what others started.",
};

// Rudhyar's eight lunation phases, each 45° of the Sun-Moon cycle. Written
// for the whole phase, not the exact lunation that opens it.
export const LUNATION_READINGS = {
  new: "You were born in the New Moon phase, the first three or so days of the Moon's cycle. You tend to act on instinct and find the reasons later.",
  crescent: "You were born in the crescent phase, as the new cycle pushes into view. You break from old patterns, often against some resistance, and that push is where your strength comes from.",
  firstQuarter: "You were born in the first quarter phase, when the cycle meets its first real test. You build under pressure and make decisions in the middle of the action.",
  gibbous: "You were born in the gibbous phase, the days of growing toward full. You tend to see what's still missing, and you keep at a thing until it feels right.",
  full: "You were born in the full Moon phase, when the cycle is at its brightest. You tend to see yourself most clearly through other people, and you feel your own contradictions sharply.",
  disseminating: "You were born in the disseminating phase, just after the peak. You take in a lot, and you need to pass it on: teaching, sharing, explaining.",
  lastQuarter: "You were born in the last quarter phase, when the cycle starts letting go. You question what everyone else takes for granted and are willing to drop what no longer works.",
  balsamic: "You were born in the balsamic phase, the last days before a new Moon. You carry a sense of finishing something, and you often see where things are heading before others do.",
};

// Sect decides which planets help more and which challenge harder.
export const SECT_READINGS = {
  day: "A day chart: the Sun was above the horizon when you were born. In traditional astrology that makes Jupiter your more helpful planet and softens Saturn, while Mars is the one that pushes hardest.",
  night: "A night chart: the Sun was below the horizon when you were born. In traditional astrology that makes Venus your more helpful planet and softens Mars, while Saturn is the one that pushes hardest.",
};

// Only the rarer personal-planet retrogrades; Jupiter and Saturn are
// retrograde for about a third of everyone.
export const RETRO_READINGS = {
  venus: "Venus was retrograde when you were born, which happens only about 7% of the time. What you value and find beautiful tends to be self-defined, sometimes against the grain.",
  mars: "Mars was retrograde when you were born (about 1 in 10 people). Your drive turns inward first: you plan, simmer, and act once you're sure, and anger tends to come out late.",
  mercury: "Mercury was retrograde when you were born (about 1 in 5 people). Your mind does its best work on the second pass: you rethink, revise, and often understand things in your own order.",
};

export const DIGNITY_LABEL = {
  domicile: "strong (in its own sign)",
  exaltation: "strong (exalted)",
  detriment: "challenged (opposite its own sign)",
  fall: "challenged (in its fall)",
  "detriment+fall": "challenged (detriment and fall)",
};
